import { ThemeIcon } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './AccessDenied.module.scss';

interface Props {
  ownerName?: string;
}

const AccessDenied = ({ ownerName }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.title}>
        {t('accessDenied.title', "Vous n'avez pas accès à ce contenu")}
      </div>
      <div className={styles.container}>
        <ThemeIcon size={120} radius={60} variant="light" color="gray">
          <IconLock size={60} />
        </ThemeIcon>
        <div className={styles.subtitle}>
          {ownerName
            ? t(
                'accessDenied.contactOwner',
                'Demandez à {{ownerName}} de vous accorder les droits nécessaires.',
                { ownerName }
              )
            : t(
                'accessDenied.contactOwnerGeneric',
                'Demandez au propriétaire du bien de vous accorder les droits nécessaires.'
              )}
        </div>
      </div>
    </>
  );
};

export default AccessDenied;
